/* eslint-disable */
/* eslint-disable prefer-template */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import styled from 'styled-components';
import { BrowserRouter as Router, Route, Switch, withRouter, Redirect, Link } from 'react-router-dom';
import { BaseComponent } from '../../components/BaseComponent';

import './style.scss';
import { Language } from '../../components/Icon';
import { Modal, ModalControls } from '../../components/Modal';
import { Button } from '../../components/Buttons';
import { makeSelectLocale } from '../LanguageProvider/selectors';
import { changeLocale } from '../LanguageProvider/actions';
import { HBox, VBox } from '../../components/Box';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

const Container = styled.div`
  color: black;
  width: 24px;
`;

export const Flag = styled.div`

    width:30px;
    height:30px;

    border-top-left-radius:16px;
    border-bottom-right-radius:16px;

    border-radius:100%;

    background-image: url('${props => props.src}');
    background-size: cover;
    background-position:center center;
    background-repeat: no-repeat;

`;

const Selection = styled.div`
  display: flex;

  img {
    width: 50px;
    height: 50px;
  }
  .flag {
    text-align: center;
    margin: 12px;
    border-radius: 40px;
    overflow: hidden;
    width: 60px;
    height: 60px;
  }
`;

const LANGS = [
  { Symbol: 'nl', name: 'Nederlands' },
  { Symbol: 'de', name: 'Deutsch' },
  { Symbol: 'en', name: 'English' },
  { Symbol: 'pl', name: 'Polski' },
];

const STATE = {};

export class LanguageSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    let lang = _.find(
      LANGS,
      l =>
        this.props.history.location.pathname == '/' + l || this.props.history.location.pathname.indexOf('/' + l + '/') === 0,
    );

    if (lang) {
      this.props.history.push(this.props.location.pathname.replace(lang.Symbol, '').replace('//', '/'));
      this.props.setLocale(lang.Symbol);
    }
  }

  get locale() {
    return this.props.locale;
  }

  getNameBySymbol(symbol) {
    const lang = LANGS.find(item => item.Symbol === symbol);
    return lang ? lang.name : null;
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    return (
      <div className="dropdown ">
        <a
          className="nav-link dropdown-toggle arrow-none d-flex align-items-center bg-transparent text-muted link-primary"
          role="button"
          id="dropdownMenuLink1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          href="#"
          style={{ height: 70, border: 'none' }}
          aria-haspopup="false"
        >
          <div className="d-flex align-items-center justify-content-start">
            <img
              className="me-sm-1 "
              src={`/public/images/${this.props.locale}.svg`}
              style={{ height: 12, marginBottom: '-2px' }}
              alt="user-image"
            />
            <span className="align-middle d-none d-lg-inline-block">{this.getNameBySymbol(this.props.locale)}</span>
          </div>
        </a>

        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink1">
          {LANGS.map(({ Symbol, name }) => (
            <li className="dropdown-item" key={Symbol} onClick={() => this.props.setLocale(Symbol)}>
              <div className="d-flex align-items-center justify-content-start">
                <img src={`/public/images/${Symbol}.svg`} style={{ width: 20, marginRight: 5, marginBottom: '-2px' }} />
                <p className="p-0 m-0 fs-6 text-muted align-middle">{name}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

LanguageSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setLocale(locale) {
      dispatch(changeLocale(locale));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const LanguageSelection = compose(withConnect, withRouter)(LanguageSelectionComp);
